import React, { useContext, useRef, useState } from 'react';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getAllPeriodicals } from '../../NecttosComp/APICaller/ApiServices';
import SearchableImput from '../../NecttosComp/Input/SearchableImput';
import { Body, closeAnimation, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

export const Periodicals = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const { data = [], refetch } = useQuery('getAllPeriodicals', getAllPeriodicals(collegeId));
	const [isLoading, setIsLoading] = useState(false);
	const [state, setState] = useState({});
	const [showForm, setShowForm] = useState(false);
	const managePeriodicals = async () => {
		try {
			setIsLoading(true);

			const instance = await getAxiosTokenInstance();
			let resp;
			resp = await instance.post('/college/action/postPeriodicals', {
				collegeId,
				bookDetails: state.bookDetails,
				vendorMobile: state.vendorMobile,
				vendor: state.vendor,
				arcgives: state.arcgives,
				bookType: state.bookType,
				language: state.language,
				subject: state.subject,
				postalAddress: state.postalAddress,
				ddAddress: state.ddAddress,
				issnNumber: state.issnNumber,
				nameOfBook: state.nameOfBook,
				piriodicity: state.piriodicity,
				price: state.price,
				_id: state?._id,
			});
			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			} else {
				setState({
					...state,

					bookDetails: '',
					vendorMobile: '',
					vendor: '',
					bookType: '',
					arcgives: '',
					language: '',
					subject: '',
					postalAddress: '',
					ddAddress: '',
					issnNumber: '',
					nameOfBook: '',
					piriodicity: '',
					price: '',

					_id: '',
				});
				refetch();
			}
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Main width='100%' height='100%' title='Periodicals Management'>
			<Header>
				<div className='flex'></div>
				<div className='flex'>
					<Button
						type='update'
						onClick={() => {
							setState({
								bookDetails: '',
								vendorMobile: '',
								vendor: '',
								arcgives: '',
								language: '',
								subject: '',
								postalAddress: '',
								bookType: '',
								ddAddress: '',
								issnNumber: '',
								nameOfBook: '',
								piriodicity: '',
								price: '',
								_id: '',
							});
							setShowForm(true);
						}}>
						Add New
					</Button>

					<Button
						type='fetch'
						onClick={() => {
							refetch();
						}}>
						Reload
					</Button>
					<Button type='print' tableRef={componentRef.current}>
						Print
					</Button>
						<Instruction keyId={'periodicals'}/>
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</div>
			</Header>

			<Body>
				<div ref={componentRef} className='printable bg-neutral-200 dark:bg-neutral-800 rounded-lg overflow-x-auto print:overflow-visible p-4'>
					<div className='min-w-[1100px] w-full flex flex-col gap-4 rounded-2xl'>
						<h5 className='text-[30px] text-center font-semibold m-0 dark:text-slate-100'>Periodicals Management</h5>

						<Table width='100%' innerWidth={['5%', '40%', '20%', '20%', '20%', '10%', '20%', '20%', '20%', '20%', '20%', '20%', '20%', '20%']}>
							<Thead>
								<Tr>
									<Th position={0} textAlign='center'>
										Sn
									</Th>
									<Th position={1}>Title</Th>
									<Th position={2}>Periodicals</Th>
									<Th position={3}>Price</Th>
									<Th position={4}>Vendor</Th>
									<Th position={5}>V Mobile</Th>
									<Th position={6}>Type</Th>
									<Th position={7}>Subject</Th>
									<Th position={8}>Language</Th>
									<Th position={9}>Archives</Th>
									<Th position={10}>Postal Address</Th>
									<Th position={11}>DD Address</Th>
									<Th position={12}>ISSN Number</Th>
									<Th position={13}>Other Details</Th>
								</Tr>
							</Thead>

							<Tbody className='print:!h-auto'>
								{data?.map((item, i) => (
									<Tr key={i} index={i}>
										<Td position={0} index={i} textAlign='center'>
											{i + 1}
										</Td>
										<Td position={1} index={i}>
											{item.nameOfBook}
										</Td>
										<Td position={2} index={i}>
											{item.piriodicity}
										</Td>
										<Td position={3} index={i}>
											{item.price}
										</Td>
										<Td position={4} index={i}>
											{item.vendor}
										</Td>
										<Td position={5} index={i}>
											{item.vendorMobile}
										</Td>
										<Td position={6} index={i}>
											{item.bookType}
										</Td>
										<Td position={7} index={i}>
											{item.subject}
										</Td>
										<Td position={8} index={i}>
											{item.language}
										</Td>
										<Td position={9} index={i}>
											{item.arcgives}
										</Td>
										<Td position={10} index={i}>
											{item.postalAddress}
										</Td>
										<Td position={11} index={i}>
											{item.ddAddress}
										</Td>
										<Td position={12} index={i}>
											{item.issnNumber}
										</Td>
										<Td position={13} index={i}>
											<div>{item.bookDetails}</div>
											<div className='flex justify-start mt-1 print:hidden'>
												<Button
													type='edit'
													onClick={() => {
														setShowForm(true);
														setState({
															_id: item?._id || '',
															bookDetails: item.bookDetails || '',
															vendorMobile: item.vendorMobile || '',
															vendor: item.vendor || '',
															arcgives: item.arcgives || '',
															bookType: item.bookType || '',
															language: item.language || '',
															subject: item.subject || '',
															postalAddress: item.postalAddress || '',
															ddAddress: item.ddAddress || '',
															issnNumber: item.issnNumber || '',
															nameOfBook: item.nameOfBook || '',
															piriodicity: item.piriodicity || '',
															price: item.price || '',
														});
													}}>
													Edit
												</Button>
											</div>
										</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				</div>
			</Body>

			{showForm && (
				<Main width='40vw' height='80vh' title={state.alert ? state.alert : 'Add New'}>
					<Header>
						<div className='flex'></div>
						<div className='flex'>
							<Button
								type='close'
								onClick={() => {
									closeAnimation();
									setTimeout(() => setShowForm(false), 500);
								}}>
								Close
							</Button>
						</div>
					</Header>
					<Body>
						<div>
							<Input2 type='drop' fieldName='Type of Periodicals' returnKey='bookType' state={state} setState={setState} options={['Journals', 'Magazines', 'Dailies']} className='w-[99%]' />
							<Input2 type='drop' fieldName='Periodicity' returnKey='piriodicity' state={state} setState={setState} options={['Daily', 'Weekly', 'Fortnightly', 'Semimonthly', 'Monthly', 'Semi-quarterly', 'Bimonthly', 'Quarterly', 'Triennially', 'Biennially', 'Annually']} className='w-[99%]' />
							<Input2 type='text' fieldName={`${state.bookType || ''} Name`} returnKey='nameOfBook' state={state} setState={setState} className='w-[99%]' />

							{state.bookType !== 'Dailies' && (
								<>
									<Input2 type='text' fieldName='ISSN No' returnKey='issnNumber' state={state} setState={setState} className='w-[99%]' />
									<Input2 type='text' fieldName='DD Address' returnKey='ddAddress' state={state} setState={setState} className='w-[99%]' />
									<Input2 type='text' fieldName='Postal Address' returnKey='postalAddress' state={state} setState={setState} className='w-[99%]' />
								</>
							)}

							{state.bookType === 'Journals' && <SearchableImput keyData='subject' titleData='Subject' collection='ddcSubjectsLibrary' stateData={state} setStateData={setState} />}

							{state.bookType === 'Magazines' && <SearchableImput keyData='language' titleData='Language' collection='books' stateData={state} setStateData={setState} />}

							{state.bookType !== 'Dailies' && <Input2 type='text' fieldName='Archives' returnKey='arcgives' state={state} setState={setState} className='w-[99%]' />}

							<SearchableImput keyData='vendor' titleData='Vendor Name & Address' collection='books' stateData={state} setStateData={setState} />
							<Input2 type='text' fieldName='Price' returnKey='price' state={state} setState={setState} className='w-[99%]' />
							<Input2 type='number' fieldName='Vendor Mobile' returnKey='vendorMobile' state={state} setState={setState} className='w-[99%]' />
							<SearchableImput keyData='bookDetails' titleData='Other Details if any' collection='books' stateData={state} setStateData={setState} />

							<div className='flex justify-between'>
								<Button
									type='close'
									onClick={() => {
										setState({
											...state,
											bookDetails: '',
											vendorMobile: '',
											vendor: '',
											arcgives: '',
											language: '',
											subject: '',
											postalAddress: '',
											bookType: '',
											ddAddress: '',
											issnNumber: '',
											nameOfBook: '',
											piriodicity: '',
											price: '',
											_id: '',
										});
									}}>
									Cancel
								</Button>
								<Button type='submit' onClick={managePeriodicals}>
									Submit
								</Button>
							</div>
						</div>
					</Body>
				</Main>
			)}
		</Main>
	);
};
